const restuarant = `Aihe: Valitus huonosta ravintolakäynnistäni
Hyvä manageri,
Haluan kertoa sinulle huonosta kokemuksestani ravintolassasi.
Kun söin siellä eilen, löysin ruoastani hiuksen, mikä oli todella karua.
Myös tarjoilija ei ollut mukava, kun kerroin heille siitä. He olivat töykeitä eivätkä näyttäneet välittävän.
Varmista, että ravintolasi on puhdas ja että henkilökuntasi on kohtelias asiakkaita kohtaan.
On tärkeää varmistaa, ettei näin käy kenellekään muulle.
Haluaisin virallisen anteeksipyynnön ja rahat takaisin.
Ajattelen myös virallisen valituksen tekemistä tästä,
Tee tarvittavat toimenpiteet, jotta tämä ei toistu`;
export default restuarant;